import MainLayout from "../components/CommonComponents/MainLayout";
import CustomerDetailsTab from "./customerDetails/CustomerDetailsTab";

export default function CustomerDetailsPage() {
    return (
        <MainLayout>
            {/* Removed card-like container for seamless background */}
            <CustomerDetailsTab />
        </MainLayout>
    );
}